let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1vnBX")).then(() => parcelRequire('5jbPW'));